import React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Modal,
  Card,
  Divider,
  Theme,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  modal: {
    maxWidth: '365px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px 30px',
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
  },
  modalMessage: {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  locationsInfo: {
    fontFamily: 'Montserrat',
    fontSize: '13px',
    fontWeight: 300,
    color: theme.palette.text.primary,
  },
  modalButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  cancelButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  acceptButton: {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'none',
  },
  closeButtonIcon: {
    padding: '0px',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

interface BranchPaymentModalProps {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const BranchPaymentModal: React.FC<BranchPaymentModalProps> = ({
  open,
  onClose,
  onAccept,
}) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modalContainer}
    >
      <Card className={classes.modal}>
        <Box className={classes.modalContent}>
          <Box className={classes.modalTitleContainer}>
            <Typography className={classes.modalTitle}>
              Advertencia
            </Typography>
            <IconButton
              className={classes.closeButtonIcon}
              onClick={onClose}
            >
              <Close />
            </IconButton>
          </Box>
          <Divider />
          <Typography className={classes.modalMessage}>
            Por favor acércate a una sucursal para completar el pago y la reserva de tu cupo.
          </Typography>

          <Typography className={classes.locationsInfo}>
            <b>Sede Escuela Militar</b>
            <br />
            Cruz del Sur N°133, oficina 702, Las Condes
          </Typography>
          <Typography className={classes.locationsInfo}>
            <b>Sede Los Dominicos</b>
            <br />
            Augusta Gerona N°1577, oficina 705, Las Condes
          </Typography>
          <Typography className={classes.locationsInfo}>
            <b>Sede La Dehesa</b>
            <br />
            Avenida La Dehesa N°1201, Torre Norte, oficina 807, Lo Barnechea
          </Typography>
          <Box className={classes.modalButtonsContainer}>
            <Button
              onClick={onClose}
              className={classes.cancelButton}
              fullWidth
            >
              Cancelar
            </Button>
            <Button
              onClick={onAccept}
              variant="contained"
              color="primary"
              className={classes.acceptButton}
              fullWidth
            >
              Aceptar y continuar
            </Button>
          </Box>
        </Box>
      </Card>
    </Modal>
  );
};

export default BranchPaymentModal;
